import React from 'react';
import { useEffect } from 'react';
import styled from '@emotion/styled';

import 'mapbox-gl/dist/mapbox-gl.css';
import useMap from '../../hooks/useMap';
import { useMapContext } from '../../contexts/mapContext';
import useSource from '../../hooks/clustered/useSource';
import usePoints from '../../hooks/clustered/usePoints';
import useClusters from '../../hooks/clustered/useClusters';
import useWidgetConfigurationHandler from 'widgets/earthMap/hooks/useWidgetConfigurationHandler';
import useSeparatedSource from 'widgets/earthMap/hooks/separated/useSaperatedSource';
import useSeparatedPoints from 'widgets/earthMap/hooks/separated/useSeparatedPoints';
import useSeparatedHoverPoints from 'widgets/earthMap/hooks/separated/hover/useSeparatedHoverPoints';
import EarthMapModal from './EarthMapModal';
import useHoveredClusterPoints from 'widgets/earthMap/hooks/clustered/hover/hoveredClusterPoints/useHoveredClusterPoints';
import useHoveredClusters from 'widgets/earthMap/hooks/clustered/hover/hoveredClusters/useHoveredClusters';
import EarthMapLegend from './EarthMapLegend';
import useSizeProperty from 'widgets/earthMap/hooks/useSizeProperty';
import ClusterModal from './ClusterModal';
import useData from 'widgets/earthMap/hooks/useData';
import FitToBoundsButton from './FitToBoundsButton';

export const EarthMapWidget = ({
	data, // geojson object
	widgetConfiguration,
	endpointQuery,
}) => {
	const [{ mapRef }, { setData }] = useMapContext();

	useEffect(() => {
		setData(data);
	}, [setData, data]);

	useWidgetConfigurationHandler({ widgetConfiguration });
	useSizeProperty({ endpointQuery });
	useMap();

	//CLUSTERED
	useSource();
	//useClusterText();
	//useHoveredClusterText();
	useHoveredClusters();
	//hovered points
	//useHoveredClusterPointText();
	useHoveredClusterPoints();
	useClusters();
	usePoints();

	//SEPARATED
	useSeparatedSource();
	//useSeparatedHoverPointText();
	useSeparatedHoverPoints();
	useSeparatedPoints();

	useData();

	return (
		<Wrapper>
			<Map ref={mapRef} />
			<EarthMapModal />
			<ClusterModal />
			<EarthMapLegend />
			<FitToBoundsButton />
		</Wrapper>
	);
};

const Map = styled.div`
	flex: 1;
	height: 100%;
`;

const Wrapper = styled.div`
	width: 100%;
	height: 100%;
	position: relative;
`;
